import Vue from 'vue'
import config from '@/config/index'

export default {
  namespaced: true,
  state: {
    defaultPagination: {
      q: '',
      sortBy: 'authority',
      page: 1,
      rowsPerPage: 10,
      descending: false,
      totalItems: 0
    }
  },
  getters: {
    defaultPagination (state) {
      return state.defaultPagination
    }
  },
  actions: {
    fetchItem ({ commit, dispatch }, id) {
      return Vue.axios.get(`${config.serverURI}/gangs/${id}`)
    },
    // create ({ commit, dispatch }, payload) {
    //   return Vue.axios.post(`${config.serverURI}/gangs`, payload)
    // },
    update ({ commit, dispatch }, payload) {
      return Vue.axios.put(`${config.serverURI}/gangs/${payload.id}`, payload)
    },
    // delete ({ commit, dispatch }, payload) {
    //   return Vue.axios.put(`${config.serverURI}/gangs/${payload.id}`, { enabled: false })
    // },
    list ({commit, state, getters}) {
      return Vue.axios.get(config.serverURI + '/gangs/list')
    },
    loadItems ({commit, state, getters}, pagination) {
      if (!pagination) pagination = getters.defaultPagination
      return Vue.axios.get(config.serverURI + '/gangs/page', { params: pagination })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/gang.js